import React from 'react';

const NoCartItems = () => {
    return <div className="text-center">
        <img src={window.location.origin + "/images/your-cart-is-empty.png"} width="300" />
    </div>;
}

export default NoCartItems;